export { default } from "./vibe-pricing-feature-component";
